/* eslint-disable @typescript-eslint/camelcase */
import intl from 'react-intl-universal'

const basicTemplateConfig = {
  created_date: {
    type: 'DateTime',
    label: intl.get('BasicTemplateConfig.createdDate.label'),
    isReadOnly: true,
    isTextOnly: true,
    default: true,
    tab: 'meta',
    description: intl.get('BasicTemplateConfig.createdDate.description'),
  },
  last_updated_date: {
    type: 'DateTime',
    label: intl.get('BasicTemplateConfig.lastUpdatedDate.label'),
    isReadOnly: true,
    isTextOnly: true,
    default: true,
    tab: 'meta',
    description: intl.get('BasicTemplateConfig.lastUpdatedDate.description'),
  },
  display_date: {
    type: 'DateTime',
    label: intl.get('BasicTemplateConfig.displayDate.label'),
    isReadOnly: '{{is_published}}',
    isTextOnly: true,
    default: true,
    tab: 'meta',
    description: intl.get('BasicTemplateConfig.displayDate.description'),
  },
  first_publish_date: {
    type: 'DateTime',
    label: intl.get('BasicTemplateConfig.firstPublishDate.label'),
    isReadOnly: true,
    isTextOnly: true,
    default: true,
    tab: 'meta',
    description: intl.get('BasicTemplateConfig.firstPublishDate.description'),
  },
  language: {
    type: 'String',
    label: intl.get('BasicTemplateConfig.language.label'),
    picklist: 'single',
    default: true,
    tab: 'meta',
    description: intl.get('BasicTemplateConfig.language.description'),
  },
  copyright: {
    type: 'String',
    label: intl.get('BasicTemplateConfig.copyright.label'),
    picklist: 'single',
    default: true,
    tab: 'meta',
    description: intl.get('BasicTemplateConfig.copyright.description'),
  },
  editor_note: {
    type: 'String',
    label: intl.get('BasicTemplateConfig.editorNote.label'),
    maxLength: true,
    isTextArea: true,
    default: true,
    tab: 'meta',
    description: '',
  },
  source_system: {
    type: 'String',
    label: intl.get('BasicTemplateConfig.sourceSystem.label'),
    path: 'source.system',
    isReadOnly: true,
    default: true,
    tab: 'meta',
    description: intl.get('BasicTemplateConfig.sourceSystem.description'),
  },
  source_type: {
    type: 'String',
    label: intl.get('BasicTemplateConfig.sourceType.label'),
    labelSpecifyingLegacy: intl.get(
      'BasicTemplateConfig.sourceType.labelSpecifyingLegacy'
    ),
    path: 'source.source_type',
    isReadOnly: false,
    default: true,
    tab: 'meta',
    description: intl.get('BasicTemplateConfig.sourceType.description'),
  },
  subtype: {
    type: 'String',
    label: intl.get('BasicTemplateConfig.subtype.label'),
    picklist: 'single',
    default: true,
    tab: 'meta',
    description: intl.get('BasicTemplateConfig.subtype.description'),
  },
  ownership_status: {
    type: 'String',
    label: intl.get('BasicTemplateConfig.ownershipStatus.label'),
    labelSpecifyingLegacy: intl.get(
      'BasicTemplateConfig.ownershipStatus.labelSpecifyingLegacy'
    ),
    picklist: 'freeText',
    path: 'owner.name',
    default: true,
    tab: 'meta',
    description: intl.get('BasicTemplateConfig.ownershipStatus.description'),
  },
  slug: {
    type: 'String',
    label: intl.get('BasicTemplateConfig.slug.label'),
    maxLength: true,
    default: true,
    tab: 'meta',
    description: intl.get('BasicTemplateConfig.slug.description'),
  },
  content_restrictions: {
    type: 'String',
    label: intl.get('BasicTemplateConfig.contentRestrictions.label'),
    path: 'content_restrictions.content_code',
    picklist: 'single',
    default: true,
    tab: 'meta',
    description: intl.get(
      'BasicTemplateConfig.contentRestrictions.description'
    ),
  },
  working_headline: {
    type: 'String',
    label: intl.get('BasicTemplateConfig.workingHeadline.label'),
    enLabel: 'Working Headline',
    maxLength: true,
    path: 'headlines.basic',
    default: true,
    tab: 'planning',
    smartQuotes: true,
    description: intl.get('BasicTemplateConfig.workingHeadline.description'),
    showCharCount: true,
  },
  creditline: {
    type: 'String',
    label: intl.get('BasicTemplateConfig.creditline.label'),
    labelSpecifyingLegacy: intl.get(
      'BasicTemplateConfig.creditline.labelSpecifyingLegacy'
    ),
    path: 'source.name',
    tab: 'meta',
    picklist: 'single',
    description: intl.get('BasicTemplateConfig.creditline.description'),
  },
  budget_line: {
    type: 'String',
    isTextArea: true,
    rows: 6,
    label: intl.get('BasicTemplateConfig.budgetLine.label'),
    path: 'planning.budget_line',
    maxLength: true,
    tab: 'planning',
    maxlength: 180,
    description: intl.get('BasicTemplateConfig.budgetLine.description'),
  },
}
export default basicTemplateConfig
